import { render, staticRenderFns } from "./AdminNonMetrcTaxonomy.vue?vue&type=template&id=60b83532&scoped=true"
import script from "./AdminNonMetrcTaxonomy.vue?vue&type=script&lang=js"
export * from "./AdminNonMetrcTaxonomy.vue?vue&type=script&lang=js"
import style0 from "./AdminNonMetrcTaxonomy.vue?vue&type=style&index=0&id=60b83532&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b83532",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60b83532')) {
      api.createRecord('60b83532', component.options)
    } else {
      api.reload('60b83532', component.options)
    }
    module.hot.accept("./AdminNonMetrcTaxonomy.vue?vue&type=template&id=60b83532&scoped=true", function () {
      api.rerender('60b83532', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/AdminNonMetrcTaxonomy.vue"
export default component.exports